import { useGetOrgId } from '@shared/hooks/use-get-org-id';
import { useGetOrganizationById } from '@shared/services/get-organization-by-id';

import { Helmet } from 'react-helmet';

export const UserHeaderMetadata = () => {
  const orgId = useGetOrgId();
  const { data } = useGetOrganizationById(orgId);
  const title = `CRM  | welcome to ${data?.name ?? 'Ticlick'}`;
  const description =
    data?.industry ||
    'At Ticlick, we’re transforming student recruitment. Our advanced CRM platform is tailored for J1 Agencies, US Designated Sponsors, Study Abroad Agencies, Language Schools, Post-Secondary Institutions, Colleges, Universities, and Volunteering Organizations. We streamline operations, simplify tasks, and enhance student relationship management, making the recruitment process smart, quick, and easy.';
  const website = data?.website ?? 'crm.ticlickcrm.com';

  return (
    <Helmet>
      <meta charSet='utf-8' />
      <title>{title}</title>
      <link
        rel='icon'
        type='image/svg+xml'
        href='/ticlick-logo.svg'
      />
      <link
        rel='canonical'
        href={website}
      />
      <meta
        name='description'
        content={description}
      />
    </Helmet>
  );
};
